module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5f6162237b9164725d1a85b3a12b9a64.png";